import { render, staticRenderFns } from "./SubjectOptions.vue?vue&type=template&id=2166f9de&scoped=true"
import script from "./SubjectOptions.vue?vue&type=script&lang=js"
export * from "./SubjectOptions.vue?vue&type=script&lang=js"
import style0 from "./SubjectOptions.vue?vue&type=style&index=0&id=2166f9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166f9de",
  null
  
)

export default component.exports